<template>
  <div class="res-top">
    <div class="res-top__part">
      <div class="res-top__photo">
        <img
          :src="getUserAvatar(managerCropUrl)"
          alt="Avatar"
          v-tooltip="{ content: managerFullName, placement: 'right', offset: 10 }"
        >
      </div>
      <div class="res-top__info res-top__info--lead">
        <div class="res-top__weight">{{ leadName ? leadName : `Lead #${leadId}`}}</div>
      </div>
      <div class="res-top__info res-top__info--gap">
        <div class="res-top__gray">Reservations:</div>
        <div class="res-top__weight">{{ leadHotelsCount }}</div>
      </div>
    </div>
    <div class="res-top__part">
      <app-button
        v-if="is_general_manager || is_reservation_supervisor"
        @click.native="onShowAssignManagerPopup(leadId)"
        size="small"
        theme="warn"
      >
        Assign manager
      </app-button>
      <app-button
        v-if="!isLeadResManager"
        @click.native="onLeadPatch(leadId)"
        size="small"
      >
        Assign to me
      </app-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppResTop',
  props: {
    managerCropUrl: String,
    managerFullName: String,
    leadName: String,
    leadId: Number,
    leadHotelsCount: Number,
    isLeadResManager: Boolean,
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_reservation_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('reservation_supervisor')
    },
  },
  methods: {
    onShowAssignManagerPopup(id) {
      this.$emit('assignManagerPopup', id)
    },
    onLeadPatch(id) {
      this.$emit('leadPatch', id)
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>

<style scoped lang="sass">
.res-top
  display: flex
  justify-content: space-between
  margin-bottom: 10px
  padding: 7px 16px
  border: 1px solid #dfdfdf
  border-radius: 10px
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08)
  background-color: #fff

.res-top__part
  display: flex
  align-items: center
  gap: 10px

.res-top__info
  display: flex
  align-items: center

.res-top__info--count
  min-width: 22px
  line-height: 1

.res-top__info--gap
  gap: 4px

.res-top__weight
  font-weight: 500

.res-top__gray
  color: #5f5f5f

.res-top__photo
  width: 31px
  border-radius: 50%
  overflow: hidden
  line-height: 0
</style>